<!--todo: Remove after sidebar done-->
<!--<ng-container [ngSwitch]="isWhiteLabel">-->
<!--  <app-wl-header-->
<!--    *ngSwitchCase="true"-->
<!--    [class]="appVersion"-->
<!--    [notMain]="!whiteLabelMain"-->
<!--  ></app-wl-header>-->

<!--  <app-core-header *ngSwitchDefault [class]="appVersion"></app-core-header>-->
<!--</ng-container>-->

<main
  class="big"
  [ngClass]="{ 'core-main': coreMain, _hidden: hideContent }"
  *ngIf="!standalone && !redirectOnly"
>
  <app-sidenav></app-sidenav>

  <div
    class="content-container"
    [ngClass]="{
      'full-width': isFullWidth,
      'no-map': hideMap
    }"
  >
    <!--    TODO change to new loader-->
    <div
      class="_bt-loader"
      [ngClass]="{
        'app-loaded': isFirstLoadEnded && isBrowser,
        loading: isFirstLoadEnded && isLoading && isBrowser
      }"
    >
      <img
        *ngIf="appConfig"
        [src]="
          ToolsHelper.minLogoUrl(
            appConfig.configsUrl,
            appConfig.settings.logo
          ) +
          '?v=' +
          nowDate
        "
        width="120px"
        height="120px"
        class="hided-image"
        alt="__logo__"
        (load)="bgLoaded($event)"
      />
      <div *ngIf="!checkOnLoaded()" class="img-placeholder pulse"></div>
      <img
        *ngIf="checkOnLoaded()"
        width="120px"
        height="120px"
        [alt]="appConfig.settings.config_name + ' logo'"
        [src]="
          ToolsHelper.minLogoUrl(
            appConfig.configsUrl,
            appConfig.settings.logo
          ) +
          '?v=' +
          nowDate
        "
      />

      <div class="text">Loading</div>
      <div class="loader" *ngIf="!isFirstLoadEnded"></div>
    </div>
    <ng-container>
      <router-outlet [class]="appVersion"></router-outlet>
    </ng-container>
  </div>

  <div class="_toggle-container" *ngIf="!hideMap" (click)="toggleContainer()">
    <mat-icon svgIcon="custom:arrows-left"></mat-icon>
  </div>
  <app-lazy-side-map
    *ngIf="coreMain !== true && !hideMap"
    [isWlMap]="isWhiteLabel"
  ></app-lazy-side-map>
</main>
<ng-container *ngIf="standalone && !redirectOnly">
  <router-outlet [class]="appVersion"></router-outlet>
</ng-container>
<ng-container *ngIf="redirectOnly">
  <router-outlet [class]="appVersion"></router-outlet>
</ng-container>
